import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

export default function AdminDashboardPage() {
  const [stats, setStats] = useState(null);
  const [recentProjects, setRecentProjects] = useState([]);

  useEffect(() => {
    axios.get('/api/admin/stats').then(r => setStats(r.data));
    axios.get('/api/projects/admin/all?limit=5').then(r => setRecentProjects(r.data.rows || []));
  }, []);

  const STATUS_COLORS = {
    draft: '#9B9A92', submitted: '#854F0B', under_review: '#854F0B',
    certified: '#1D9E75', rejected: '#A32D2D',
  };
  const STATUS_LABELS = {
    draft: 'Bozza', submitted: 'In attesa', under_review: 'In revisione',
    certified: 'Certificato', rejected: 'Rifiutato',
  };

  return (
    <>
      <div className="topbar">
        <span className="topbar-title">Dashboard certificatore</span>
        <span style={{ fontSize: 13, color: '#9B9A92' }}>{new Date().toLocaleDateString('it-IT', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</span>
      </div>
      <div className="page-content">
        {/* KPIs */}
        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-label">Progetti totali</div>
            <div className="stat-value">{stats?.total ?? '—'}</div>
          </div>
          <div className="stat-card">
            <div className="stat-label">In attesa di revisione</div>
            <div className="stat-value" style={{ color: '#854F0B' }}>{stats?.submitted ?? '—'}</div>
            <div className="stat-sub">Da esaminare</div>
          </div>
          <div className="stat-card">
            <div className="stat-label">Certificati emessi</div>
            <div className="stat-value" style={{ color: '#1D9E75' }}>{stats?.certified ?? '—'}</div>
          </div>
          <div className="stat-card">
            <div className="stat-label">Non approvati</div>
            <div className="stat-value" style={{ color: '#A32D2D' }}>{stats?.rejected ?? '—'}</div>
          </div>
          <div className="stat-card">
            <div className="stat-label">Clienti attivi</div>
            <div className="stat-value">{stats?.clients ?? '—'}</div>
          </div>
          <div className="stat-card">
            <div className="stat-label">Score medio ESG</div>
            <div className="stat-value" style={{ color: '#1D9E75' }}>
              {stats?.avgScorePercentage != null ? `${stats.avgScorePercentage}%` : '—'}
            </div>
            <div className="stat-sub">{stats?.avgScore ?? '—'}/{stats?.maxScore ?? 125} punti</div>
          </div>
        </div>

        {/* Recent projects */}
        <div className="table-container">
          <div className="table-header">
            <h3>Progetti recenti</h3>
            <Link to="/admin/projects" className="btn btn-outline btn-sm">Vedi tutti →</Link>
          </div>
          <table>
            <thead>
              <tr>
                <th>Progetto</th>
                <th>Azienda</th>
                <th>Data invio</th>
                <th>Punteggio</th>
                <th>Stato</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {recentProjects.map(p => (
                <tr key={p.id}>
                  <td style={{ fontWeight: 500 }}>{p.name}</td>
                  <td style={{ color: '#5C5B55' }}>{p.company?.name || '—'}</td>
                  <td style={{ color: '#9B9A92' }}>{p.submittedAt ? new Date(p.submittedAt).toLocaleDateString('it-IT') : '—'}</td>
                  <td>
                    {p.scoreTotal > 0
                      ? `${p.scorePercentage != null ? Math.round(p.scorePercentage) : Math.round((p.scoreTotal / 125) * 100)}%`
                      : '—'}
                  </td>
                  <td>
                    <span style={{ fontSize: 12, fontWeight: 500, color: STATUS_COLORS[p.status] }}>
                      {STATUS_LABELS[p.status]}
                    </span>
                  </td>
                  <td>
                    <Link to={`/admin/projects/${p.id}`} className="btn btn-ghost btn-sm" style={{ color: '#1D9E75' }}>
                      Esamina →
                    </Link>
                  </td>
                </tr>
              ))}
              {recentProjects.length === 0 && (
                <tr><td colSpan={6} style={{ textAlign: 'center', color: '#9B9A92', padding: 32 }}>Nessun progetto</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
